export default "__VITE_ASSET__KmdY9Ecg__"